module.exports = __webpack_public_path__ + "static/media/enabledCriticalIcon.bb997ff2.svg";